/* eslint-disable no-use-before-define ,no-dupe-keys , jsx-a11y/label-has-associated-control,object-shorthand */



import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import '../signup/Registration.css';
import CommonDialog from 'components_newui/dialogs/CommonDialog';
import logo_red from '../../img/innovate/Innovation_Logo.jpg'

const AdminCreateUser = (props) => {
    const history = useHistory()
    const { postAdminCreateUserFn , postAdminCreateUserIsLoading} = props
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [isloading, setLoading] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        role:'',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Registration attempt:', formData);
        postAdminCreateUserFn(formData)
    };

    return (

        <div className="auth-container">
            
            <div className="auth-card">
            <h3>Note: This registration is intended for admin use only.</h3>
                <div className="auth-header">
                    <div className="nova-logo">
                        <img className="logored" src={logo_red} alt="logo" />
                    </div>
                    <h1>New User Registration</h1>
                    <p>Join the Innovate+ community</p>
                </div>
                
                <form onSubmit={handleSubmit} className="auth-form">
                    <div className="form-group">
                        <label htmlFor="firstName">First Name</label>
                        <input
                            type="text"
                            id="firstName"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            required
                            placeholder="Enter your first  name"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="lastName">Last Name</label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}

                            placeholder="Enter your last name"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email Address</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="Enter your email address"
                        />
                        {validationErrors.email && (
                            <div className="error-message">
                                <small>{validationErrors.email}</small>
                            </div>
                        )}

                    </div>

                    <div className="form-group">
                        <select 
                            name="role" 
                            value={formData.role}
                            onChange={handleChange} 
                            required>
                            <option value="">Select Your Role</option>
                            <option value="Admin">Admin</option>
                            <option value="Evaluator">Evaluator</option>
                            <option value="Normal">Normal</option>
                        </select>
                    </div>

                    <button
                        type="submit"
                        className='auth-button primary'
                        disabled={postAdminCreateUserIsLoading}
                    >
                        {postAdminCreateUserIsLoading ? " Loading... " : 'Create Account'}
                    </button>
                </form>

            </div>

            {/* <CommonDialog
        open={showSuccessModal}
        title="Registration successfully!"
        cancelText='Okay'
        hideSubmitBtn
        content='The email is on its way! Check your inbox in a few moments and follow the instructions to set your password.'
        // onClose={redirectLoginpage}
      />  */}


        </div>

    )
}

export default AdminCreateUser
